<template>
  <div class="attendance">
    <div class="attendance-title">
      <div class="attendance-title-info">
        <img :src="childInfo.avatar" alt="" />
        <div class="msg">
          <p>{{ childInfo.userName }}</p>
          <p>{{ childInfo.className }}</p>
        </div>
      </div>
      <div class="time-select">
        <van-icon name="arrow-left" @click="prevArrow" />
        <span style="margin: 0 5%" @click="selectDate">{{ date }}</span>
        <van-icon name="arrow" @click="nextArrow" />
        <SelectTime
          ref="startmonth"
          :typeTime="'选择月份'"
          @time="handleTimeStartConfirm"
          :minDate="minDate"
          :maxDate="new Date()"
          type="year-month"
          :currentDate="startMinTime"
        />
      </div>
    </div>
    <div class="attendance-content">
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1" class="vanitem">
          <template #title>
            <div class="title">
              出勤（<span style="color: #37a5da">{{ attendance || "0" }}</span
              >天）
            </div>
          </template>
          <div class="content">
            <div
              class="column"
              v-for="(column, cIndex) in dataList.attendanceDates"
              :key="cIndex"
            >
              <div
                class="span"
                v-for="(span, sIndex) in column"
                :key="sIndex"
                @click="hrefOtherPage(span)"
              >
                {{ span }}
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item name="2" class="vanitem">
          <template #title>
            <div class="title">
              缺勤（<span style="color: #37a5da">{{ absence || "0" }}</span
              >天）
            </div>
          </template>
          <div class="content">
            <div
              class="column"
              v-for="(column, cIndex) in dataList.absenceDates"
              :key="cIndex"
            >
              <div
                class="span"
                v-for="(span, sIndex) in column"
                :key="sIndex"
                @click="hrefOtherPage(span)"
              >
                {{ span }}
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item name="3" class="vanitem">
          <template #title>
            <div class="title">
              请假（<span style="color: #37a5da">{{ leave || "0" }}</span
              >次）
            </div>
          </template>
          <div class="content">
            <div
              class="leave-column"
              v-for="(column, index) in dataList.leaves"
              :key="index"
              @click="hrefOtherPage(column)"
            >
              {{ column }}
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
// let data = {
//   attendance: [
//     "2021-05-01",
//     "2021-05-02",
//     "2021-05-03",
//     "2021-05-04",
//     "2021-05-05",
//     "2021-05-07",
//     "2021-05-08",
//     "2021-05-09",
//     "2021-05-10",
//     "2021-05-21",
//     "2021-05-22",
//   ],
//   absence: [
//     "2021-05-12",
//     "2021-05-13",
//     "2021-05-14",
//     "2021-05-17",
//     "2021-05-19",
//     "2021-05-20",
//     "2021-05-25",
//   ],
//   leave: [
//     {
//       startTime: "2021-05-23 09:00:00",
//       endTime: "2021-05-23 17:00:00",
//       num: 6,
//     },
//     {
//       startTime: "2021-05-28 10:00:00",
//       endTime: "2021-05-28 12:00:00",
//       num: 7,
//     },
//   ],
// };
import SelectTime from "@/components/subScribePopup/selectTime";
import moment from "moment";
export default {
  data() {
    return {
      childInfo: {},

      date: '',
      minDate: new Date(2020, 0),
      startMinTime: new Date(moment().format("YYYY-MM")),

      activeNames: [],
      attendance: 0,
      absence: 0,
      leave: 0,
      dataList: [],
      week: [
        "周日",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六",
      ],
    };
  },
  components: { SelectTime },
  mounted() {
    console.log('路由参数获取',JSON.parse(this.$route.query.data))
    this.childInfo = JSON.parse(this.$route.query.data);
    this.date=this.childInfo.current
    this.activeNames = this.activeNames.concat(this.$route.query.type);

    this.getMonthAttendence()
  },
  methods: {
    async getMonthAttendence() {
      this.startTime=this.date+'-01'
      let days=this.getDayNumByYearMonth(this.date.slice(0,4),this.date.slice(5,7))
      this.endTime=this.date+'-'+days
      const { data, code } = await this.$https.getAttendanceCountByStudentId({
        studentId: this.childInfo.userId,
        beginDate: this.startTime,
        endDate: this.endTime
      });
      if (code !== 200) {
        return false;
      }
      if(data!=null){
        if(data.attendanceDates!=null){
          this.attendance = data.attendanceDates.length;
          data.attendanceDates= this.changeArr(data.attendanceDates, 3);
        } else {
          this.attendance = 0
        }
        if(data.absenceDates!=null){
          this.absence = data.absenceDates.length;
          data.absenceDates = this.changeArr(data.absenceDates, 3);
        } else {
          this.absence = 0
        }
        if(data.leaves!=null){
          this.leave = data.leaves.length;
          data.leaves = this.setLeaveArr(data.leaves);
        } else {
           this.leave = 0
        }
        this.dataList=data
      }
    },
    //是否是闰年
    isLeapYear(year){
        if(year/4 == 0 && year/100 != 0){
            return true ;
        } else if (year/400 == 0){
            return true ;
        } else{
            return false ;
        }
    },
    //根据年月得到天数
    getDayNumByYearMonth(year,month){
        switch (month) {
            case '01':
            case '03':
            case '05':
            case '07':
            case '08':
            case '10':
            case '12':
                return 31;
                break;
            case '04':
            case '06':
            case '09':
            case '11':
                return 30;
                break;
            case '02':
                return this.isLeapYear(year) ? 29 : 28;
        }
    },
    //判断是否是ios系统
    appSource() {
      const u = navigator.userAgent, app = navigator.appVersion;
      //const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      return isiOS
    },
    handleTimeStartConfirm(time) {
      var timeDate=time
      var ios=this.appSource()
      if(ios){
        timeDate= time.replace(/-/g,'/')
      }
      this.date = moment(new Date(timeDate)).format("YYYY-MM");
      this.getMonthAttendence()
    },
    selectDate() {
      this.$refs.startmonth.showTimePopup = true;
    },
    prevArrow() {
      let date = new Date(
        new Date(this.date).setMonth(new Date(this.date).getMonth() - 1)
      );
      if (new Date(date).getTime() < new Date("2020-01").getTime()) return;
      this.date = moment(new Date(date)).format("YYYY-MM");
      this.getMonthAttendence()
    },
    nextArrow() {
      let date = new Date(
        new Date(this.date).setMonth(new Date(this.date).getMonth() + 1)
      );
      if (new Date(date).getTime() > new Date().getTime()) return;
      this.date = moment(new Date(date)).format("YYYY-MM");
      this.getMonthAttendence()
    },
    changeArr(arr, num) {
      let newArr = [];
      for (let i = 0; i < Math.ceil(arr.length / num); i++) {
        newArr.push([]);
      }
      arr.forEach((item, index) => {
        newArr[Math.floor(index / num)].push(
          `${moment(item.date).format("MM-DD")}(${
            this.week[new Date(item.date).getDay()]
          })`
        );
      });
      return newArr;
    },
    setLeaveArr(arr) {
      return arr.map((item) => {
        return (
          moment(item.beginDate).format("MM-DD HH:mm") +
          "————" +
          moment(item.endDate).format("MM-DD HH:mm") +
          "共计" +
          item.duration +
          "小时"
        );
      });
    },

    hrefOtherPage(span) {
      console.log('JSON.stringify(this.childInfo)',this.childInfo)
      var selectCurrent=this.date.slice(0,4)+'-'+span.slice(0,5)
      this.$router.push({
        path: "/studentMonthCalendar",
        query: { date: this.date, childInfo: JSON.stringify(this.childInfo),today:selectCurrent },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.attendance {
  padding-top: 10px;
  .attendance-title {
    width: 90%;
    height: 54px;
    margin-left: 5%;
    padding: 8px 8px;
    background: white;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .attendance-title-info {
      display: flex;
      align-items: center;
      img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        margin-right: 6px;
      }
      .msg {
        :nth-child(1) {
          font-size: 16px;
        }
        :nth-child(2) {
          font-size: 14px;
          color: #666666;
        }
      }
    }
    .time-select {
      display: flex;
      align-items: center;
      width: 110px;
    }
  }
  .attendance-content {
    background: white;
    width: 90%;
    border-radius: 8px;
    margin-left: 5%;
    margin-top: 3%;
    overflow: scroll;
    .vanitem {
      .title {
        border-left: 2.5px solid #37a5da;
        height: 16px;
        font-size: 16px;
        line-height: 16px;
        padding-left: 5px;
      }
      .content {
        width: 100%;
        .column {
          display: flex;
          align-items: center;
          height: 39px;
          line-height: 39px;
          font-size: 14px;
          color: black;
          .span {
            width: 33%;
            text-align: center;
          }
        }
        .leave-column {
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          color: black;
          text-align: center;
        }
        > div:not(:last-child) {
          border-bottom: 0.5px solid #e4e4e4;
        }
      }
    }
  }
}

.vanitem ::deep .van-cell__title {
  display: flex;
  align-items: center;
}
</style>